import type { RecurringRequirement } from "@investhinks/api-client";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import StructureRequirementsCard from "../RequirementsCard";

type PartialRequirement = {
  [K in keyof RecurringRequirement]?: RecurringRequirement[K] | null;
};

interface PartnerRecurringRequirementsCardProps {
  requirements?: PartialRequirement[];
  isLoading: boolean;
  compact?: boolean;
}

const PartnerRecurringRequirementsCard: React.FC<PartnerRecurringRequirementsCardProps> = ({
  requirements = [],
  isLoading,
  compact = false,
}) => {
  const { t } = useTranslation("referrer", { keyPrefix: "partner.partnerRequirementsFulfillmentCard" });
  const { t: tRequirements } = useTranslation("referrer", { keyPrefix: "requirementsCard" });

  const parsedRequirements = useMemo(
    () =>
      requirements.map((req) => {
        const current = req.current ?? 0;
        const required = req.required ?? 0;
        const name = req.name ?? "";
        return {
          code: name,
          text: req.description || tRequirements(name, { current, required }),
          checked: req.met ?? false,
          warning: !req.met && current < required,
          color: !req.met && ("danger" as const),
        };
      }),
    [requirements, tRequirements]
  );

  return (
    <StructureRequirementsCard
      requirements={parsedRequirements}
      title={t("title")}
      isLoading={isLoading}
      compact={compact}
    />
  );
};

export default PartnerRecurringRequirementsCard;
